export default __webpack_public_path__ + "static/media/DSCN2202.25fd52f7.jpg";